module.exports = __webpack_public_path__ + "img/nh-collection-lisboa-liberdade.9e0f0da6.jpg";